import axios from 'axios';
import Resource from './Resource'

export default class RegularCounsel extends Resource {
  static ENDPOINT = '/api/regularcounsel'

  constructor (args) {
    super()
    this.counsels = []
    this.extend(args)
  }

  static create (training, student, counseler) {
    const counsels = []
    // counsels.push({
    //   counseler: counseler,
    //   content: '',
    //   action: '',
    //   regDate: new Date()
    // })
    return new RegularCounsel({ training, student, counsels })
  }
}
